import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import React from "react";
import './ContactSection.css';
import email from "../assets/images/email.png";
import phone from "../assets/images/phone.png";
import address from "../assets/images/address.png";
import facebook from "../assets/images/fb.png";
import instagram from "../assets/images/insta.png";
import twitter from "../assets/images/tweet.png";

export const ContactSection = () => {
    return (
        <div className="contactSection" id="contactsSectionId">
                <Container>
                    <Col className="steakCol" sm={12} lg={12}>
                        <p className="mainTitle">Contact Details</p>
                    </Col>

                    <Row>
                    <Col className="contactCol" sm={12} lg={4}>
                        <div className="emailCard">
                            <img className="contactIcon aBitMoreTopMargin" src={email} alt="email icon"/>
                            <br/>
                            <a className="contactLinks" href="mailto:Volunteering@Street-link.ie">Volunteering@Street-link.ie</a>
                            <br/>
                            <a className="contactLinks" href="mailto:Fundraising@Street-link.ie">Fundraising@Street-link.ie</a>
                            <br/>
                            <a className="contactLinks" href="mailto:Info@Street-link.ie">Info@Street-link.ie</a>
                        </div>

                    </Col>

                    <Col className="contactCol" sm={12} lg={4}>
                        <div className="emailCard">
                            <img className="contactIcon moreTopMargin" src={phone} alt="phone icon"/>
                            <br/>
                            <a className="contactLinks" href="tel:018167073">01-2343752</a>
                            <br/>
                            <a className="contactLinks" href="tel:0874347052">0874347052</a>
                        </div>
                    </Col>

                    <Col className="contactCol" sm={12} lg={4}>
                        <div className="emailCard">
                            <img className="contactIcon" src={address} alt="phone icon"/>
                            <br/>
                            <p className="contactLinks">
                                Streetlink Homeless Support CLG<br/>
                                Suite 11103<br/>
                                26/27 Upper Pembroke Street<br/>
                                Dublin 2,
                                D02X361<br/> </p>
                        </div>
                    </Col>

                    <Col className="contactCol" sm={12} lg={4}>
                        <div className="emailCard">
                            <img className="contactIcon moreTopMargin" src={facebook} alt="phone icon"/>
                            <br/>
                            <a className="contactLinks" href="https://www.facebook.com/SHS.Dublin" target="_blank" rel="noreferrer">
                                https://www.facebook.com/SHS.Dublin
                            </a>
                        </div>
                    </Col>

                    <Col className="contactCol" sm={12} lg={4}>
                        <div className="emailCard">
                            <img className="contactIcon moreTopMargin" src={instagram} alt="phone icon"/>
                            <br/>
                            <a className="contactLinks" href="https://www.instagram.com/streetlinkhs/" target="_blank" rel="noreferrer">
                                https://www.instagram.com/streetlinkhs/
                            </a>
                        </div>
                    </Col>

                    <Col className="contactCol" sm={12} lg={4}>
                        <div className="emailCard">
                            <img className="contactIcon moreTopMargin" src={twitter} alt="phone icon"/>
                            <br/>
                            <a className="contactLinks" href="https://twitter.com/StreetlinkBAC" target="_blank" rel="noreferrer">
                                https://twitter.com/StreetlinkBAC
                            </a>
                        </div>
                    </Col>
                    </Row>
                </Container>
        </div>
    )
}